import { Component, Input, ElementRef, ViewChild, OnChanges, AfterViewInit } from '@angular/core';
import { LatLngBounds } from '@agm/core';
import { ObraDTO } from 'src/app/models/dtos/obra-dto';
import { take, concatMap } from 'rxjs/operators';
import { CapaService } from 'src/app/services/capa.service';
import { from, Subscription } from 'rxjs';
import { Capa } from 'src/app/models/entities/capa';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { SegmentoService } from 'src/app/services/segmento.service';
import { Segmento } from 'src/app/models/entities/segmento';
declare const google: any;
@Component({
  selector: 'formato-pdf-ficha-tecnica',
  templateUrl: './formato-pdf-ficha-tecnica.component.html',
  styleUrls: ['./formato-pdf-ficha-tecnica.component.scss']
})
export class FormatoPdfFichaTecnicaComponent implements OnChanges {

  @ViewChild('formatoHtmlPDF')
  public formatoHtmlPDF: ElementRef;

  @Input('obraSeleccionada')
  public obraSeleccionada: ObraDTO;
  public elementosObra: Segmento[] = [];

  // public rutasFotosFull: any[];
  // public rutasFotosAvance: any[];
  // public rutasFotosEstructura: any[];
  // public rutasFotosProblematica: any[];

  public map: any;
  public marcadorInicial: any;
  public marcadorFinal: any;

  public latActual: any;
  public lngActual: any;
  public zoomActual: any;

  public FOTOS_POR_PAGINA = 4;
  public TIPO_OBRA_PROCESO: string = '0';
  public colores: ElementoCatalogo[] = [];
  public datosCoordenadas: any;
  public datosCoordenadasVariosSegmentos: any[] = [];
  public colorCapa: any;
  public suscripcionColores: Subscription;

  public fechaActual: any;
  public tipoCarpetaYSeccion: any;

  checked: boolean = false;
  checked2: boolean = true;
  public informacionCargada: boolean = false;

  public marker: any = {
    url: '../../../../../assets/img/iconos/marker-red.png',
    scaledSize: {
      width: 25,
      height: 25
    }
  };

  public catalogoColores: ElementoCatalogo[] = [];
  public catCorredores: ElementoCatalogo[] = [];
  public readonly KEY_COLOR_CAPA_PROYECTO_PROCESO: string = '0';
  public readonly KEY_COLOR_CAPA_PROYECTO_PLANEACION: string = '4';
  public HEX_COLOR_CAPA_PROYECTO_PROCESO: string = '';
  public HEX_COLOR_CAPA_PROYECTO_PLANEACION: string = '';
  public readonly CAPA_PROYECTO_PROCESO: string = 'Proceso';

  constructor(
    private segmentoService: SegmentoService,
    private capaService: CapaService,
    private catalogoService: CatalogoService,
    private elem: ElementRef
  ) { }

  public ngOnChanges(): void {
    // this.rutasFotosFull = this.rellenarArregloConObjetosVacios(this.fichaTecnica.rutasFotosFull);
    // this.rutasFotosAvance = this.rellenarArregloConObjetosVacios(this.fichaTecnica.rutasFotosAvance);
    // this.rutasFotosEstructura = this.rellenarArregloConObjetosVacios(this.fichaTecnica.rutasFotosEstructura);
    // this.rutasFotosProblematica = this.rellenarArregloConObjetosVacios(this.fichaTecnica.rutasFotosProblematica);
    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    const carpetas = ["Asfáltica", "Hidráulica", "Rodaderas"];
    const secciones = ["A1", "A2", "A3", "A4", "6M", "7M", "9M"]
    let fechaConvert: Date = new Date(this.obraSeleccionada.obra.fechaActualizacion);
    this.fechaActual = (fechaConvert.getUTCDate() + " de " + monthNames[fechaConvert.getUTCMonth()] + " de " + fechaConvert.getUTCFullYear());
    this.tipoCarpetaYSeccion = carpetas[this.obraSeleccionada.obra.keyCatCarpeta] + " - " + secciones[this.obraSeleccionada.obra.keyCatSeccion];
    this.obtenerCatalogos();
    this.obtenerCoordenadas();
  }

  // public rellenarArregloConObjetosVacios(source: any[]): any[] {
  //   if (source) {
  //     let dest = source.slice(0);
  //     let cantidadFotosFaltantes = this.FOTOS_POR_PAGINA - source.length;
  //     for (let indice = 0; indice < cantidadFotosFaltantes; indice++) {
  //       dest.push({});
  //     }
  //     return dest;
  //   }
  // }

  public async obtenerCatalogos() {
    this.catalogoColores = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES).pipe(take(1)).toPromise();
    this.catCorredores = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CORREDORES).pipe(take(1)).toPromise();
    this.HEX_COLOR_CAPA_PROYECTO_PROCESO = this.catalogoColores.find((c: ElementoCatalogo) => c.key === this.KEY_COLOR_CAPA_PROYECTO_PROCESO).nombre;
    this.HEX_COLOR_CAPA_PROYECTO_PLANEACION = this.catalogoColores.find((c: ElementoCatalogo) => c.key === this.KEY_COLOR_CAPA_PROYECTO_PLANEACION).nombre;
  }

  public async obtenerCoordenadas() {
    this.elementosObra = await this.capaService.findByKeyLevantamientoObra(this.obraSeleccionada.obra.keyLevantamientoObra).pipe(
      take(1),
      concatMap((capas: Capa[]) => from(capas).pipe(
        concatMap((capa: Capa) => this.segmentoService.findByKeyCapa(capa.key).pipe(take(1))
        ))
      ),
      take(1)
    ).toPromise();
    for (let index = 0; index < this.elementosObra.length; index++) {
      this.datosCoordenadasVariosSegmentos.push(this.elementosObra[index].coordenadas);
    }
    this.datosCoordenadas = this.elementosObra[0].coordenadas;
    this.obtenerMarcadorInicial();
    this.obtenerMarcadorFinal();
    this.informacionCargada = true;
  }

  public obtenerMarcadorInicial(): void {
    this.marcadorInicial = {
      lat: this.elementosObra[0].coordenadas[this.elementosObra[0].coordenadas.length - 1].latitud,
      lng: this.elementosObra[0].coordenadas[this.elementosObra[0].coordenadas.length - 1].longitud
    };
  }

  public obtenerMarcadorFinal(): void {
    this.marcadorFinal = {
      lat: this.elementosObra[0].coordenadas[0].latitud,
      lng: this.elementosObra[0].coordenadas[0].longitud
    };
  }

  public mapReady(event: any, mapa: any): void {
    this.map = event;
    this.centrarPolyline();
  }

  public centrarPolyline(): void {
    const bounds: LatLngBounds = new google.maps.LatLngBounds();
    for (const elementoObra of this.datosCoordenadas) {
      bounds.extend(new google.maps.LatLng(elementoObra.latitud, elementoObra.longitud));
    }
    this.map.fitBounds(bounds);
  }

  public cambioZoom(event: any): void {
    this.zoomActual = event;
  }

  public cambioCentro(event: any): void {
    this.latActual = event.lat;
    this.lngActual = event.lng;
  }

  public obtenerNombreCorredor(keyCorredor: string): string {
    return this.catCorredores.find((corredor: ElementoCatalogo) => corredor.key === keyCorredor).nombre;
  }

  public ngOnDestroy(): void {
    if (this.suscripcionColores) {
      this.suscripcionColores.unsubscribe();
    }
  }

}